module.exports = __webpack_public_path__ + "img/playstore-g.4151a612.svg";